export default {
  noteOnFormulaChanges: null,
  approvedDate: null,
  createAt: null,
  updateAt: null,
  status: null,
  projectNumber: undefined,
  projectType: undefined
};
